import BodyTitleComponent from '@components/history/historyItem/body/bodyTitleComponent';
import NotificationHolderComponent from '@components/history/historyItem/body/notifications/notificationHolderComponent';
import TasksHolderComponent from '@components/history/historyItem/body/tasks/tasksHolderComponent';
import AppContext from '@services/Context';
import { Badge, Col, Icon, Row, Timeline } from 'antd';
import moment from 'moment';
import React from 'react';

import I18n from '../../../../i18n';
import styled, { Theme } from '../../../../styled-components';

interface IProp {
    id: number
    register: any
    type: string
}

interface IState {
    collapsed: boolean
    tasks: any
}

class TimelineItemComponent extends React.Component<IProp, IState> {

    state = {
        collapsed: true,
        tasks: undefined,
    }

    constructor(prop: IProp) {
        super(prop);
    }

    toggleCollapsed() {
        if (this.state.collapsed) {
            this.setState({
                collapsed: !this.state.collapsed,
                tasks: this.props.register.value.tasks
            })
        } else {
            this.setState({
                collapsed: !this.state.collapsed,
                tasks: undefined
            })
        }
    }

    renderTimelineSignature(register: any, type: string) {
        let startAtDate: Date = new Date(register.startAt);
        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <div className="goepik-timeline-signature">
                        <Row className="goepik-text-right goepik-side-padding">
                            <Col sm={24} md={24} xl={24}>
                                <p className="goepik-component-no-margin-bottom">{moment(startAtDate).format(I18n.l('common.dateTimeFormat'))}</p>
                            </Col>
                        </Row>
                        {/* <Row className="goepik-text-right goepik-side-padding">
                                <Col sm={24} md={24} xl={24}>
                                    <p className="goepik-component-no-margin-bottom">{I18n.l('history.timeline.end.label')} {this.props.data.endDate} {this.props.data.endTime}</p>
                                </Col>
                            </Row> */}
                        {
                            (type === "process") &&
                            <Row className="goepik-text-right goepik-side-padding">
                                <Col sm={24} md={24} xl={24}>
                                    <p className="goepik-component-no-margin-bottom">{register.user.name}</p>
                                </Col>
                            </Row>
                        }
                    </div>
                )}
            </AppContext.Consumer>
        )
    }

    getProcessNameFromRegister(register: any, type: string) {
        switch (type) {
            case "process": {
                if (register.process) {
                    return register.process.name;
                }
                return 'PROCESS' // TODO: refactor tickets 
            }

            case "notification": {
                return register.value.content;
            }

            default:
                return "errorOnType at GetProcessNameFromRegister";
        }
    }

    getStatusFromRegister(register: any, locale: any, type: string) {
        switch (type) {
            case "process":
                if (register.result) {
                    return (
                        <h4 className="goepik-status-done">
                            <Icon type="check-circle" />
                            {I18n.l('common.status')} "{I18n.l('global.taskflow.status.done')}"
                        </h4>
                    )
                } else {
                    return (
                        <h4 className="goepik-status-error">
                            <Icon type="close-circle" />
                            {I18n.l('common.status')} "{I18n.l('global.taskflow.status.error')}"
                        </h4>
                    )
                }
                break;

            case "notification":
                if (register.value.sent) {
                    return (
                        <h4 className="goepik-status-done">
                            <Icon type="check-circle" />
                            {I18n.l('common.status')} "{I18n.l('global.notification.status.done')}"
                        </h4>
                    )
                } else {
                    return (
                        <h4 className="goepik-status-error">
                            <Icon type="close-circle" />
                            {I18n.l('common.status')} "{I18n.l('global.notification.status.error')}"
                        </h4>
                    )
                }
                break;

            default:
                return <div>@Content not available</div>
                break;
        }
    }

    render(): JSX.Element {
        const { register } = this.props;

        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <GoEpikTimelineItem>
                        <Timeline.Item key={this.props.id} dot={<Badge count={(this.props.id + 1)} className="goepik-timeline-number" />}>
                            {
                                this.renderTimelineSignature(register, this.props.type)
                            }
                            <Row className="goepik-side-padding">
                                <Col sm={24} md={24} xl={24}>
                                    <div className="goepik-clickable" onClick={this.toggleCollapsed.bind(this)}>
                                        <BodyTitleComponent title={this.getProcessNameFromRegister(register, this.props.type)} collapsed={this.state.collapsed} />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="goepik-side-padding">
                                <Col sm={24} md={24} xl={24}>
                                    {
                                        this.getStatusFromRegister(register, locale, this.props.type)
                                    }
                                </Col>
                            </Row>
                            {
                                (!this.state.collapsed &&
                                    <Row className="goepik-side-padding">
                                        <Col sm={24} md={24} xl={24}>
                                            {
                                                ((this.props.type === "process") &&
                                                    <TasksHolderComponent tasks={register.value.tasks} />
                                                )
                                            }
                                            {
                                                (this.props.type == "notification" &&
                                                    <NotificationHolderComponent
                                                        body={register.value.subject}
                                                        receivers={register.workflowEvent.profiles}
                                                        notifyFailed={register.value.sent}
                                                    />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                )
                            }
                        </Timeline.Item>
                    </GoEpikTimelineItem>
                )}
            </AppContext.Consumer>
        );
    }
};

const GoEpikTimelineItem = styled.div`
    .goepik-timeline-number{
        .ant-badge-count{
            background-color: ${Theme.primary.regular}!important;
            color: ${Theme.standard.white}!important;
            box-shadow: '0 0 0 1px #d9d9d9 inset!important'
        }
    }

    .goepik-timeline-signature{
        min-height: 83px!important;
        position: absolute;
        padding-left: 24px;
        padding-right: 24px;
        left: -18em;
    }

    .goepik-text-right{
        text-align: right;
    }

    .goepik-side-padding{
        padding-left: 24px!important;
        padding-right: 24px!important;
    }

    .goepik-component-no-margin-bottom{
        margin-bottom: 0px!important;
        margin-left: 20px;
    }

    .goepik-clickable{
        cursor: pointer;
    }
`;

export default TimelineItemComponent;
